
import { v4 as uuidv4 } from "uuid";
import { FloatingFeature } from "@models";
import { 
  UpgradableNumber 
} from "@dndModels";

/**
 * This represents a Book that a spellcaster is 
 * able to keep their spells in.  
 * It's primarily for Wizards, 
 * but Pact of the Tome Warlocks who take the 
 * Book of Ancient Secrets Eldritch Invocation
 * also gain access to it.
 * The Warlock one can only hold Rituals, and they
 * don't prepare from it, but they're allowed to
 * learn from ANY spell list, where Wizards can 
 * only learn from the Wizard Spell List
 * (which is the largest one by far).
 */
export class Spellbook extends FloatingFeature {
  spells_known: UpgradableNumber = new UpgradableNumber();
  // spells_at_level_1: number;
  // spells_add_per_level: number;
  // extra_booked_from_ability: string; // This increases the number of spells to add to the Spellbook, not to prepare
  rituals_only = false; // All, No Cantrips, Rituals Only
  spell_list = ""; // All, or id of spell_list
  supplies_spells = false;
  knowledge_usage_key = "";

  /**
   * From Wizard 5e - Spellcasting, "Your Spellbook"
   * You might find other spells during your adventures. 
   * You could discover a spell recorded on a scroll in an evil wizard’s chest, 
   * for example, or in a dusty tome in an ancient library.
   * 
   * Copying a Spell into the Book. When you find a wizard spell of 1st level or higher, 
   * you can add it to your spellbook if it is of a spell level you can prepare 
   * and if you can spare the time to decipher and copy it.
   * 
   * Copying that spell into your spellbook involves reproducing the basic form of the spell, 
   * then deciphering the unique system of notation used by the wizard who wrote it. 
   * 
   * You must practice the spell until you understand the sounds or gestures required, 
   * then transcribe it into your spellbook using your own notation.
   * 
   * For each level of the spell, the process takes 2 hours and costs 50 gp. 
   * The cost represents material components you expend as you experiment with the spell to master it, 
   * as well as the fine inks you need to record it. Once you have spent this time and money, 
   * you can prepare the spell just like your other spells.
   * 
* 
* Plans: Add fields for time/level and gold/level.
* Make these modifiable, but it can't be done using the standard modifier feature type, 
* because it needs to allow changing unit as well.

   * 
   * In Add Spells to Book, show text from spellbook and modifier if present at top,
   * and have pay to add button next to current add button, like the buy button in inventory.
   */
  learning_message = "";
  time_num_per_spell_level: UpgradableNumber = new UpgradableNumber(2);
  time_unit = 4; // Hours
  cost_per_spell_level: UpgradableNumber = new UpgradableNumber(50);
  cost_unit = 4; // GP

  can_modify_spells_at_level = -1;
  modified_spells_allowed_at_level = -1;
  modifications_cause_level_up = false;

  constructor(obj?: any) {
    super(obj);
    this.feature_type = "Spellbook";
    if (obj) {
      if (obj.spells_known) {
        this.spells_known = new UpgradableNumber(obj.spells_known);
      } else if (obj.spells_at_level_1) {
        // Translate old set up to new
        this.spells_known = new UpgradableNumber();
        this.spells_known.base = +obj.spells_at_level_1;
        if (obj.spells_add_per_level) {
          this.spells_known.add_source_level_mult = +obj.spells_add_per_level;
        }
        if (obj.extra_booked_from_ability) {
          // this.spells_known.add_ability_scores = [obj.extra_booked_from_ability];
          // this.spells_known.add_ability_mod_mult = 1;
          this.spells_known.add_stats_groups = [{ 
            true_id: uuidv4().toString(),
            add_ability_scores: [obj.extra_booked_from_ability],
            mod_or_score: "Mod",
            add_mult: 1,
            multiple_type: "And"
          }];
        }
      } else {
        this.spells_known = new UpgradableNumber();
      }
      this.rituals_only = obj.rituals_only ? obj.rituals_only : (obj.limitations ? obj.limitations === "Rituals Only" : false);
      this.supplies_spells = obj.supplies_spells ? obj.supplies_spells : false;
      this.spell_list = obj.spell_list ? obj.spell_list : "ALL";
      
      this.knowledge_usage_key = obj.knowledge_usage_key ? obj.knowledge_usage_key : "";

      this.learning_message = obj.learning_message ? obj.learning_message : "";
      this.time_num_per_spell_level = obj.time_num_per_spell_level ? new UpgradableNumber(obj.time_num_per_spell_level) : new UpgradableNumber(2);
      this.time_unit = typeof obj.time_unit === "number" ? obj.time_unit : 4;
      this.cost_per_spell_level = obj.cost_per_spell_level ? new UpgradableNumber(obj.cost_per_spell_level) : new UpgradableNumber(50);
      this.cost_unit = typeof obj.cost_unit === "number" ? obj.cost_unit : 4;

      this.can_modify_spells_at_level = obj.can_modify_spells_at_level ? obj.can_modify_spells_at_level : -1;
      this.modified_spells_allowed_at_level = obj.modified_spells_allowed_at_level ? obj.modified_spells_allowed_at_level : -1;
      this.modifications_cause_level_up = obj.modifications_cause_level_up ? obj.modifications_cause_level_up : false;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     if (obj.spells_known) {
  //       this.spells_known = new UpgradableNumber(obj.spells_known);
  //     } else if (obj.spells_at_level_1) {
  //       // Translate old set up to new
  //       this.spells_known = new UpgradableNumber();
  //       this.spells_known.base = +obj.spells_at_level_1;
  //       if (obj.spells_add_per_level) {
  //         this.spells_known.add_source_level_mult = +obj.spells_add_per_level;
  //       }
  //       if (obj.extra_booked_from_ability) {
  //         this.spells_known.add_ability_scores = [obj.extra_booked_from_ability];
  //         this.spells_known.add_ability_mod_mult = 1;
  //       }
  //     } else {
  //       this.spells_known = new UpgradableNumber();
  //     }
  //     this.rituals_only = obj.rituals_only ? obj.rituals_only : (obj.limitations ? obj.limitations === "Rituals Only" : false);
  //     this.supplies_spells = obj.supplies_spells ? obj.supplies_spells : false;
  //     this.spell_list = obj.spell_list ? obj.spell_list : "ALL";
      
  //     this.knowledge_usage_key = obj.knowledge_usage_key ? obj.knowledge_usage_key : "";

  //     this.learning_message = obj.learning_message ? obj.learning_message : "";
  //     this.time_num_per_spell_level = obj.time_num_per_spell_level ? new UpgradableNumber(obj.time_num_per_spell_level) : new UpgradableNumber(2);
  //     this.time_unit = typeof obj.time_unit === "number" ? obj.time_unit : 4;
  //     this.cost_per_spell_level = obj.cost_per_spell_level ? new UpgradableNumber(obj.cost_per_spell_level) : new UpgradableNumber(50);
  //     this.cost_unit = typeof obj.cost_unit === "number" ? obj.cost_unit : 4;

  //     this.can_modify_spells_at_level = obj.can_modify_spells_at_level ? obj.can_modify_spells_at_level : -1;
  //     this.modified_spells_allowed_at_level = obj.modified_spells_allowed_at_level ? obj.modified_spells_allowed_at_level : -1;
  //     this.modifications_cause_level_up = obj.modifications_cause_level_up ? obj.modifications_cause_level_up : false;
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      spells_known: this.spells_known.toDBObj(),
      // spells_at_level_1: this.spells_at_level_1,
      // spells_add_per_level: this.spells_add_per_level,
      // extra_booked_from_ability: this.extra_booked_from_ability,
      rituals_only: this.rituals_only,
      supplies_spells: this.supplies_spells,
      spell_list: this.spell_list,
      knowledge_usage_key: this.knowledge_usage_key,
      learning_message: this.learning_message,
      time_num_per_spell_level: this.time_num_per_spell_level.toDBObj(),
      time_unit: this.time_unit,
      cost_per_spell_level: this.cost_per_spell_level.toDBObj(),
      cost_unit: this.cost_unit,
      can_modify_spells_at_level: this.can_modify_spells_at_level,
      modified_spells_allowed_at_level: this.modified_spells_allowed_at_level,
      modifications_cause_level_up: this.modifications_cause_level_up
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof Spellbook) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: Spellbook) {
    this.spells_known = copyMe.spells_known.clone();
    this.rituals_only = copyMe.rituals_only;
    this.supplies_spells = copyMe.supplies_spells;
    this.spell_list = copyMe.spell_list;
    this.knowledge_usage_key = copyMe.knowledge_usage_key;
    this.learning_message = copyMe.learning_message;
    this.time_num_per_spell_level = copyMe.time_num_per_spell_level.clone();
    this.time_unit = copyMe.time_unit;
    this.cost_per_spell_level = copyMe.cost_per_spell_level.clone();
    this.cost_unit = copyMe.cost_unit;
    this.can_modify_spells_at_level = copyMe.can_modify_spells_at_level;
    this.modified_spells_allowed_at_level = copyMe.modified_spells_allowed_at_level;
    this.modifications_cause_level_up = copyMe.modifications_cause_level_up;
  }

  clone(drop_ids = false): Spellbook {
    const new_obj = new Spellbook();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  get spells_at_level_1() {
    return this.spells_known.base;
  }

  get spells_add_per_level() {
    return this.spells_known.add_source_level_mult;
  }
}

/**
 * 
  * From Order of Scribes Wizard - Wizardly Quill:
  * The time you must spend to copy a spell into your spellbook equals 2 minutes per spell level 
  * if you use the quill for the transcription.

  * From Abjuration WIzard 5e - Abjuration Savant: 
  * Beginning when you select this school at 2nd level, the gold and time you must spend to copy 
  * an abjuration spell into your spellbook is halved.
  * 
  * From Abjurer Wizard 1D&D - Abjuration Savant:
  * Choose two Abjuration spells from the Wizard spell list, each of which must be no higher than level 2, 
  * and add them to your spellbook for free. 
  * In addition, whenever you gain access to a new level of spell slots in this class, 
  * you can add one Abjuration spell from the Wizard spell list to your spellbook for free.
 */
export class SpellbookModifier extends FloatingFeature {
  // spell_list: string = ""; // All, or id of spell_list
  schools: string[] = [];
  learning_message = "";
  extra_free_spells: UpgradableNumber = new UpgradableNumber();
  time_num_per_spell_level: UpgradableNumber = new UpgradableNumber(2);
  time_unit = 4; // Hours
  cost_per_spell_level: UpgradableNumber = new UpgradableNumber(50);
  cost_unit = 4; // GP

  constructor(obj?: any) {
    super(obj);
    this.feature_type = "Spellbook Modifier";
    if (obj) {
      // this.spell_list = obj.spell_list ? obj.spell_list : "";
      this.schools = obj.schools ? obj.schools : [];
      this.learning_message = obj.learning_message ? obj.learning_message : "";
      this.extra_free_spells = obj.extra_free_spells ? new UpgradableNumber(obj.extra_free_spells) : new UpgradableNumber();
      this.time_num_per_spell_level = obj.time_num_per_spell_level ? new UpgradableNumber(obj.time_num_per_spell_level) : new UpgradableNumber(2);
      this.time_unit = typeof obj.time_unit === "number" ? obj.time_unit : 4;
      if (obj.time_unit && typeof obj.time_unit !== "number" && obj.time_unit !== "Hours") {
        this.time_unit = 3; // Minutes
      }
      this.cost_per_spell_level = obj.cost_per_spell_level ? new UpgradableNumber(obj.cost_per_spell_level) : new UpgradableNumber(50);
      this.cost_unit = typeof obj.cost_unit === "number" ? obj.cost_unit : 4;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     // this.spell_list = obj.spell_list ? obj.spell_list : "";
  //     this.schools = obj.schools ? obj.schools : [];
  //     this.learning_message = obj.learning_message ? obj.learning_message : "";
  //     this.extra_free_spells = obj.extra_free_spells ? new UpgradableNumber(obj.extra_free_spells) : new UpgradableNumber();
  //     this.time_num_per_spell_level = obj.time_num_per_spell_level ? new UpgradableNumber(obj.time_num_per_spell_level) : new UpgradableNumber(2);
  //     this.time_unit = typeof obj.time_unit === "number" ? obj.time_unit : 4;
  //     if (obj.time_unit && typeof obj.time_unit !== "number" && obj.time_unit !== "Hours") {
  //       this.time_unit = 3; // Minutes
  //     }
  //     this.cost_per_spell_level = obj.cost_per_spell_level ? new UpgradableNumber(obj.cost_per_spell_level) : new UpgradableNumber(50);
  //     this.cost_unit = typeof obj.cost_unit === "number" ? obj.cost_unit : 4;
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      // spell_list: this.spell_list,
      schools: this.schools,
      learning_message: this.learning_message,
      extra_free_spells: this.extra_free_spells.toDBObj(),
      time_num_per_spell_level: this.time_num_per_spell_level.toDBObj(),
      time_unit: this.time_unit,
      cost_per_spell_level: this.cost_per_spell_level.toDBObj(),
      cost_unit: this.cost_unit,
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SpellbookModifier) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: SpellbookModifier) {
    // this.spell_list = copyMe.spell_list;
    this.schools = [...copyMe.schools];
    this.learning_message = copyMe.learning_message;
    this.extra_free_spells = copyMe.extra_free_spells.clone();
    this.time_num_per_spell_level = copyMe.time_num_per_spell_level.clone();
    this.time_unit = copyMe.time_unit;
    this.cost_per_spell_level = copyMe.cost_per_spell_level.clone();
    this.cost_unit = copyMe.cost_unit;
  }

  clone(drop_ids = false): SpellbookModifier {
    const new_obj = new SpellbookModifier();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}
